import { getGenericFormInitialValues } from "../../../../components/form/utils/initialValues";

export const getLillyCopaySignatureFormInitialValues = ({ applicationForm, formJson }) => {
  const initialValues = getGenericFormInitialValues(applicationForm, formJson);

  if (initialValues?.patient?.primaryLanguage) {
    const language = initialValues.patient.primaryLanguage.toLowerCase();
    if (language !== "english" && language !== "spanish") {
      initialValues.patient.primaryLanguage = "other";
    }
  }

  return initialValues;
};
